import { useGetDocumentTagByNameQuery } from 'features/documents/documents';

export function useGetDocumentTagByName(documentId, name, skip = false) {
    const { tag } = useGetDocumentTagByNameQuery(
        { documentId, name },
        {
            selectFromResult: (result) => ({
                tag: result.currentData,
            }),
            skip,
        },
    );

    return tag;
}
